import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import NewChips from '../../common/NewChips';
import { BUILDING_TYPE_ID } from '../../../../utils/helpers/constants';
import { useBuildingType } from '../../../../hooks/useBuildingType';

const newOrSecondaryEstate = [
  {
    value: BUILDING_TYPE_ID.FLAT_NEW,
    name: 'new_search.new_building',
    id: 'new-search-form-new-building'
  },
  {
    value: BUILDING_TYPE_ID.FLAT_SECONDARY,
    name: 'new_search.secondary_building',
    id: 'new-search-form-second-hand-building'
  }
];

export const NewSearchNewOrSecondaryEstate = forwardRef((_, ref) => {
  const { t } = useTranslation();
  const categoryIds = useSelector(state => state.searchForm.categoryIds);
  const { updateCategoryIds } = useBuildingType();
  const [categoryIdsLocal, setCategoryIdsLocal] = useState(categoryIds);

  function onNewChipClick(id) {
    setCategoryIdsLocal(prev => updateCategoryIds(prev, id));
  }

  useImperativeHandle(
    ref,
    () => {
      return {
        getCategoryIdsLocal: () => categoryIdsLocal
      };
    },
    [categoryIdsLocal]
  );

  return (
    <div className="filters__section">
      <p className="filters__secondary-text">
        {t('search.form.building_type_group.title')}
      </p>
      <div className="filters__options-wrapper">
        {newOrSecondaryEstate.map(building => (
          <NewChips
            key={building.id}
            stat={building.id}
            text={t(building.name)}
            useDirtyAsActive
            dirty={categoryIdsLocal?.includes(building.value)}
            hasCustomOnChange
            onClick={() => onNewChipClick(building.value)}
          />
        ))}
      </div>
    </div>
  );
});

NewSearchNewOrSecondaryEstate.displayName = 'NewSearchNewOrSecondaryEstate';
